<nav compact tuiSubheader [style.position]="'sticky'" class="bg-white">
  <tui-breadcrumbs [itemsLimit]="10">
    <ng-container *ngFor="let item of breadcrumbs; let last = last">
      <ng-container *ngIf="last; else notLast">
        <strong *tuiItem tuiFade>
          {{ item.label }}
        </strong>
      </ng-container>
      <ng-template #notLast>
        <button
          *tuiItem
          tuiLink
          type="button"
          (click)="navigate(item.link)"
          [disabled]="!item.link"
        >
          {{ item.label }}
        </button>
      </ng-template>
    </ng-container>
  </tui-breadcrumbs>
</nav>

<section class="w-full">
  <p class="text-4xl font-normal mt-[0.9rem]">Generate New Invoice</p>
  <form [formGroup]="invoiceForm" (ngSubmit)="saveInvoice()">
    <div class="flex mt-5">
      <div>
        <p class="text-base font-medium text-[#3E4A58] my-0 w-[155px]">
          Client Infomation
        </p>
        <p class="text-sm font-normal text-[#949494D9] my-0 w-[155px]">
          Select the client
        </p>
      </div>
      <div class="pl-[167px] w-full xl:w-3/5 2xl:w-3/5">
        <tui-combo-box
          formControlName="client"
          [tuiTextfieldLabelOutside]="true"
          [stringify]="stringify"
          placeholder="Select Client"
          >Select Client
          <tui-data-list-wrapper
            *tuiDataList
            [items]="clients | tuiFilterByInput"
            [itemContent]="stringify | tuiStringifyContent"
          >
          </tui-data-list-wrapper>
        </tui-combo-box>
        <label class="flex items-center gap-2 text-xs text-[#191C30E5] select-none mt-1">
          <input
            type="checkbox"
            [checked]="includeInactiveClients"
            (change)="toggleIncludeInactiveClients(!includeInactiveClients)"
          />
          Include inactive / archived clients
        </label>
        <p
          *ngIf="isSelectedClientInactive()"
          class="text-xs text-[#8a6d1a] mt-1 flex items-center gap-1"
        >
          <span class="inline-flex items-center justify-center w-4 h-4 rounded-full bg-[#fde68a] text-[#92400e] text-[10px] font-bold">!</span>
          This client is archived or inactive; saving will use historical data only.
        </p>
        <tui-error
          formControlName="client"
          class="mb-3"
          [error]="[] | tuiFieldError | async"
        />

        <label tuiLabel>
          <tui-input class="mb-3" formControlName="email">
            Email
            <input tuiTextfieldLegacy type="text" />
          </tui-input>
        </label>

        <label tuiLabel>
          <tui-input class="mb-3" formControlName="phoneNumber">
            Phone Number
            <input tuiTextfieldLegacy type="text" />
          </tui-input>
        </label>

        <div class="w-full mb-3">
          <label tuiLabel>
            <tui-textarea
              formControlName="address"
              [tuiTextfieldLabelOutside]="true"
              placeholder="Enter Address"
              title="Textarea Input"
            >
              Address
            </tui-textarea>
          </label>
        </div>
      </div>
    </div>
    <div class="flex">
      <div>
        <p class="text-base font-medium text-[#3E4A58] my-0 w-[155px]">
          Billing Information
        </p>
        <p class="text-sm font-normal text-[#949494D9] my-0 w-[155px]">
          Enter Billing Information
        </p>
      </div>
      <div class="pl-[167px] w-full xl:w-3/5 2xl:w-3/5">
        <label tuiLabel>
          <tui-input-date formControlName="admissionDate"
            >Admission Date<input tuiTextfieldLegacy 
          /></tui-input-date>
          <tui-error
            formControlName="admissionDate"
            class="mb-3"
            [error]="[] | tuiFieldError | async"
          />
        </label>

        <label tuiLabel>
          <tui-input-date formControlName="dischargeDate" [min]="minDischargeDate">
            Billing Date<input tuiTextfieldLegacy type="text" />
          </tui-input-date>
          <tui-error
            formControlName="dischargeDate"
            class="mb-3"
            [error]="[] | tuiFieldError | async"
          />
        </label>
      </div>
    </div>
    <div class="flex">
      <div class="mt-5">
        <p class="text-base font-medium text-[#3E4A58] my-0 w-[120px]">
          Current Bill
        </p>
        <p class="text-sm font-normal text-[#949494D9] my-0">Enter</p>
      </div>
      <div class="pl-[200px] mt-5">
        <div
          *ngIf="charges.hasError('atLeastOne') && (charges.touched || invoiceForm.touched)"
          class="mb-3 text-sm font-medium text-[#8a6d1a] flex items-center gap-2"
        >
          <span
            class="inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#fde68a] text-[#92400e] text-xs font-bold"
            aria-hidden="true"
            >!</span
          >
          Add at least one charge line before saving the invoice.
        </div>
        <div class="w-full xl:w-1/3 2xl:w-full">
          <table
            *ngIf="charges.controls.length > 0"
            tuiTable
            size="m"
            class="w-[30rem] md:w-[22rem] lg:w-[37rem] xl:w-[50rem] 2xl:w-[70rem]"
          >
            <thead>
              <tr>
                <th tuiTh style="background-color: #f9fbff">Description</th>
                <th tuiTh style="background-color: #f9fbff">Qyt</th>
                <th tuiTh style="background-color: #f9fbff">Unit Price</th>
                <th tuiTh style="background-color: #f9fbff">Total</th>
              </tr>
            </thead>
            <tbody tuiTbody>
              <tr *ngFor="let charge of charges.controls; let i = index">
                <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
                  <div tuiCell="m">
                    <p class="text-[#526ED3] text-sm">
                      {{ charge.get("description")?.value }}
                    </p>
                  </div>
                </td>
                <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
                  <div tuiCell="m">
                    <p class="text-[#191C30E5] text-sm">
                      {{ charge.get("quantity")?.value }}
                    </p>
                  </div>
                </td>
                <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
                  <div tuiCell="m">
                    <p class="text-[#191C30E5] text-sm">
                      LKR {{ charge.get("unitPrice")?.value | number:'1.2-2' }}
                    </p>
                  </div>
                </td>
                <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
                  <div tuiCell="m">
                    <p class="text-[#191C30E5] text-sm">
                      LKR {{ charge.get("total")?.value | number:'1.2-2' }}
                    </p>
                    <button
                      (click)="onRemoveCharge(i)"
                      tuiButton
                      appearance="outline"
                      type="button"
                    >
                      Remove
                    </button>
                    <button
                    (click)="onEditCharge(i)"
                    tuiButton
                    appearance="outline"
                    type="button"
                  >
                    Edit
                  </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          formGroupName="newCharge"
          class="flex items-center space-x-3 flex-wrap"
        >
          <label tuiLabel class="">
            <tui-input
              formControlName="description"
              class="mt-3 lg:w-[210px] xl:w-[300px] 2xl:w-[500px]"
            >
              Description
              <input tuiTextfieldLegacy type="text" />
            </tui-input>
            <tui-error
              formControlName="description"
              class="mb-3"
              [error]="[] | tuiFieldError | async"
            />
          </label>
          <label tuiLabel>
            <tui-input
              formControlName="quantity"
              class="mt-3 xl:w-[155px] 2xl:w-[220px]"
            >
            Quantity
              <input tuiTextfieldLegacy type="text" />
            </tui-input>
            <tui-error
              formControlName="quantity"
              class="mb-3"
              [error]="[] | tuiFieldError | async"
            />
          </label>
          <label tuiLabel>
            <tui-input formControlName="unitPrice" class="mt-3 2xl:w-[220px]">
              Unit Price
              <input tuiTextfieldLegacy type="text" />
            </tui-input>
            <tui-error
              formControlName="unitPrice"
              class="mb-3"
              [error]="[] | tuiFieldError | async"
            />
          </label>
          <!-- Add the (click) event handler here -->
          <button
            (click)="onAddCharge()"
            appearance="outline"
            tuiButton
            type="button"
            class="bg-black"
          >
            Add Charge
          </button>
        </div>
      </div>
    </div>

    <div class="flex items-start mt-5">
      <div>
        <p class="text-base font-medium text-[#3E4A58] my-0 w-full">
          Total Value
        </p>
        <p class="text-sm font-normal text-[#949494D9] my-0 w-full">
          Total Amount calculated based on product quantities and unit prices
        </p>
      </div>
      <div class="flex flex-col items-end justify-end w-[55%]">
        <div class="flex w-full max-w-md items-baseline justify-end gap-x-10">
          <p class="text-left flex-1 min-w-0 text-base font-bold text-[#000000A6] m-0 p-0">
            Sub Total
          </p>
          <p
            class="text-right shrink-0 text-base font-normal text-[#777777] tabular-nums whitespace-nowrap m-0 p-0"
          >
            LKR {{ subtotal | number : '1.2-2' }}
          </p>
        </div>
        <div class="mt-5 space-x-5 flex justify-end">
          <button
            [routerLink]="['/admin/invoice']"
            appearance="outline"
            tuiButton
            type="button"
            class="bg-black"
          >
            Cancel
          </button>
          <button
            appearance="primary"
            tuiButton
            type="submit"
            class="w-[180px]"
            title="Submit"
            [appDisableUnlessPermission]="newInvoice ? 'INVOICE_CREATE' : 'INVOICE_UPDATE'"
          >
            {{ newInvoice ? "Generate Invoice" : "Edit Invoice" }}
          </button>
        </div>
      </div>
    </div>
  </form>
</section>
